import styled from 'styled-components';

const ChartWrapper = styled.div`
  &:not(:first-child) {
    margin-top: 1.5rem;
  }
`;

export default ChartWrapper;
